<template>
  <div class="zyc-info-page-table-content">
    <div class="zyc-info-table-layout" :style="{ 'border-radius':borderRadius + 'px' }">
      <table class="zyc-info-table" cellpadding="0" cellspacing="0">
        <thead>
          <tr>
            <th v-if="isNumber" style="width:80px;">序号</th>
            <th v-for="i in option.columns" :align="i.align" :style="{ width:i.width }"><zyc-tooltipText :title="i.name"></zyc-tooltipText></th>
          </tr>
        </thead>
        <tbody>
          <div v-if="isLoading" class="el-loading-mask" style=""><div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div></div>
          <tr v-for="(i,index) in data" @click="rowClick(i)">
            <td v-if="isNumber"  style="width:80px;">{{ serialMumber[index] }}</td>
            <template v-for="c in option.columns">
              <td :style="{ width:c.width, 'text-align':c.align }">
                <template v-if="c.isInfo">
                  <el-button type="text" @click="c.infoClick(i)">{{ c.infoText }}</el-button>
                </template>
                <template v-else>
                  <div :style="{ 'width':c.width, 'text-align': typeof(c.textAlign) == 'undefined'? typeof(c.align) == 'undefined' ? '':c.align: c.textAlign, 'display':'inline-block' }">
                    <template v-if="c.reSetTitle">
                      {{ c.reSetTitle }}
                    </template>
                    <template v-else>
                      <template v-if="isTooltip">
                        <zyc-tooltipText :title="i[c.prop]"></zyc-tooltipText>
                      </template>
                      <template v-else>
                        {{ i[c.prop] }}
                      </template>
                    </template>
                  </div>
                </template>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div v-if="data.length < 1" class="zyc-info-table-empty">暂无数据</div>
    </div>
    <template v-if="isPage && total > pageSize">
      <el-pagination @size-change="pageSizeChange"
                     @current-change="pageIndexChange"
                     :current-page="pageIndex"
                     :page-sizes="[10, 30, 50]"
                     :page-size="pageSize"
                     :layout="isTotal? 'total, slot, prev, pager, next, jumper':'slot, prev, pager, next, jumper'"
                     class="mt20 mb20"
                     :total="total">
        <div key="1" class="el-select el-select--mini zyc-selectPagination">
          <el-select v-model="value" @change="customPageSizeChange">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-pagination>
    </template>
  </div>
</template>
<script>
  /**
  * 排行Table
  */
  export default {
    name: 'zycInfoPageTable',
    props: {
      data: {
        type: Array,
        default: () => []
      },
      option: {
        type: Object,
        default: () => {}
      },
      pageIndex: {
        type: Number,
        default: 1
      },
      pageSize: {
        type: Number,
        default: 10
      },
      total: {
        type: Number,
        default: 0
      },
      rowClick: {
        type: Function,
        default: () => { }
      },
      sizeChange: {
        type: Function,
        default: () => { }
      },
      pageChange: {
        type: Function,
        default: () => { }
      },
      isNumber: {
        type: Boolean,
        default: false
      },
      isPage: {
        type: Boolean,
        default: true
      },
      borderRadius: {
        type: Number,
        default: 6
      },
      isTotal: {
        type: Boolean,
        default: true
      },
      isTooltip: {
        type: Boolean,
        default: true
      }
    },
    model: {
    },
    watch: {
      data: {
        handler: function (newVal, oldVal) {
          this.serialMumberPage(this.pageIndex, this.pageSize)
          this.$forceUpdate()
        },
        immediate: true
      },
      pageSize(val) {
        if (val) {
          this.value = val
        }
      }
    },
    data() {
      return {
        setUpDialog: {
          isDialog: false
        },
        isLoading: false,
        serialMumber: [],
        options: [{
          value: 10,
          label: '10条/页'
        }, {
          value: 30,
          label: '30条/页'
        }, {
          value: 50,
          label: '50条/页'
        }],
        value: 10,
        isFullScreen: false
      }
    },
    mounted() {
      
    },
    created() {
      this.serialMumberPage(1)
      window.addEventListener('resize', this.onresize)
    },
    methods: {
      showSetUp: function () {
        this.setUpDialog.isDialog = true
      },
      showLoad: function () {
        this.isLoading = true
      },
      onresize(event) {
        if (document.webkitIsFullScreen) {
          this.isFullScreen = true
        } else {
          this.isFullScreen = false
        }
      },
      hideLoad: function () {
        this.isLoading = false
      },
      pageSizeChange: function (val) {
        this.sizeChange(val)
        this.serialMumberPage(1, val)
      },
      pageIndexChange: function (val) {
        this.serialMumberPage(val)
        this.pageChange(val)
      },
      serialMumberPage: function (page,size) {
        this.serialMumber = []
        if (!size) {
          size = this.pageSize
        }
        for (var i = page * size - size + 1; i <= page * size; i++) {
          this.serialMumber.push(i)
        }
      },
      customPageSizeChange: function () {
        this.pageSizeChange(this.value)
      }
    }
  }
</script>
<style scoped lang="scss">
  /deep/ .el-pagination {
    .more + .number {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/zyc/table/pageInfoTable.vue